import { render, staticRenderFns } from "./EditOrAddMenu.vue?vue&type=template&id=98eb5a80&scoped=true"
import script from "./EditOrAddMenu.vue?vue&type=script&lang=ts"
export * from "./EditOrAddMenu.vue?vue&type=script&lang=ts"
import style0 from "./EditOrAddMenu.vue?vue&type=style&index=0&id=98eb5a80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98eb5a80",
  null
  
)

export default component.exports